import {GetMetaDataResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/browse_page/v1/meta/service.types';
import React, {FC} from 'react';

export const PageMetaDataJsonLdView: FC<GetMetaDataResponse> = ({meta}) => {
  if (meta.type?.$case !== 'seoData') {
    return null;
  }

  return meta.type.seoData.jsonLd.map((jsonLd, index) => {
    return (
      <script
        key={`onlineStoreJsonLd-${index}`}
        type="application/ld+json"
        data-testid={`onlineStoreJsonLd-${index}`}
        dangerouslySetInnerHTML={{
          __html: jsonLd,
        }}
      />
    );
  });
};
